import { thankYouNoteConstants } from '../constants';
import { saveParams, deleteParams, createParams } from './base.reducers';

const name = 'thankYouNotes';

const initialState = {
	saveLoading: 0,
	saveSuccess: false,
	deleteLoading: 0,
	allLoading: 0,

	thankYouNotes: [],
	thankYouNotesById: {}
};

export default (state = initialState, payload) => {
	const { type, data } = payload;
	switch (type) {
		// Save and edit thank you notes
		case thankYouNoteConstants.SAVING_THANK_YOU_NOTE_REQUEST:
			return {
				...state,
				saveSuccess: false,
				saveLoading: state.saveLoading + 1,
			};
		case thankYouNoteConstants.SAVING_THANK_YOU_NOTE_SUCCESS:
			const { form } = data;
			return {
				...saveParams({ name, state, form }),
				saveLoading: state.saveLoading - 1,
				saveSuccess: true
			};
		case thankYouNoteConstants.SAVING_THANK_YOU_NOTE_FAILURE:	
			return {
				...state,
				saveLoading: state.saveLoading - 1,
			};
		// Delete thank you note
		case thankYouNoteConstants.DELETE_THANK_YOU_NOTE_REQUEST:
			return {
				...state,
				deleteLoading: state.deleteLoading + 1,
			};
		case thankYouNoteConstants.DELETE_THANK_YOU_NOTE_SUCCESS:
			const id = data;
			return {
				...deleteParams({ name, state, id }),
				deleteLoading: state.deleteLoading - 1
			};
		case thankYouNoteConstants.DELETE_THANK_YOU_NOTE_FAILURE:	
			return {
				...state,
				deleteLoading: state.deleteLoading + 1,
			};
		// Load thank you notes
		case thankYouNoteConstants.LOAD_THANK_YOU_NOTES_REQUEST:
			return {
				...state,
				allLoading: state.allLoading + 1,
			};
		case thankYouNoteConstants.LOAD_THANK_YOU_NOTES_SUCCESS:
			return {
				...createParams({ name, state, data: data.data }),
				allLoading: state.allLoading - 1
			};
		case thankYouNoteConstants.LOAD_THANK_YOU_NOTES_FAILURE:	
			return {
				...state,
				allLoading: state.allLoading - 1,
			};
		default:
			return state;
	}
};


// WEBPACK FOOTER //
// ./src/redux/reducers/thankYouNote.reducers.js